// import React, { useState, useEffect, useContext } from "react";
// import { Star, ChevronRight } from "lucide-react";
// import axios from "axios";
// import { authContext } from 'contexts/AuthContext';

// const FavoriteGrade = ({ vendorId }) => {
//     const [products, setProducts] = useState([]);
//     const [allGrades, setAllGrades] = useState([]);
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [selectedSector, setSelectedSector] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const { auth } = useContext(authContext);

//     // Fetch products and grades
//     useEffect(() => {
//         const fetchData = async () => {
//             if (!vendorId) {
//                 setError('Vendor ID is required');
//                 setLoading(false);
//                 return;
//             }

//             try {
//                 setLoading(true);
//                 const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;

//                 // Fetch both APIs in parallel
//                 const [productsResponse, gradesResponse] = await Promise.all([
//                     axios.get(`${baseURL}grades/products`),
//                     axios.get(`${baseURL}grades/getall`)
//                 ]);

//                 setProducts(productsResponse.data);

//                 // Map grades data with isFavorite from traders array
//                 const gradesWithFavorites = gradesResponse.data.data.map(grade => {
//                     // Use vendorId from props instead of auth.data.id
//                     const currentVendorId = vendorId ? parseInt(vendorId) : null;
//                     const isFavorite = grade.traders?.some(trader =>
//                         parseInt(trader.id) === currentVendorId
//                     ) || false;

//                     return {
//                         ...grade,
//                         isFavorite
//                     };
//                 });

//                 setAllGrades(gradesWithFavorites);

//                 // Set first product as selected by default
//                 if (productsResponse.data.length > 0) {
//                     const firstProduct = productsResponse.data[0].name;
//                     setSelectedProduct(firstProduct);

//                     // Get sectors for first product
//                     const sectorsForProduct = getSectorsForProduct(firstProduct, gradesWithFavorites);
//                     if (sectorsForProduct.length > 0) {
//                         setSelectedSector(sectorsForProduct[0].name);
//                     }
//                 }

//                 setError(null);
//             } catch (err) {
//                 console.error('Error fetching data:', err);
//                 setError('Failed to load data');
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [vendorId]); // Add vendorId to dependencies

//     // Get unique sectors for a product with their IDs
//     const getSectorsForProduct = (productName, gradesData = allGrades) => {
//         const sectorsMap = new Map();
//         const currentVendorId = vendorId ? parseInt(vendorId) : null;

//         console.log('Current Vendor ID from props:', currentVendorId);

//         gradesData
//             .filter(grade => grade.product === productName && grade.subCategory && grade.subCategoryId)
//             .forEach(grade => {
//                 if (!sectorsMap.has(grade.subCategoryId)) {
//                     // Check if any grade in this sector is favorited
//                     const isSectorFavorite = gradesData
//                         .filter(g => g.product === productName && g.subCategory === grade.subCategory)
//                         .some(g => g.traders?.some(trader => parseInt(trader.id) === currentVendorId));

//                     sectorsMap.set(grade.subCategoryId, {
//                         name: grade.subCategory,
//                         id: grade.subCategoryId,
//                         isFavorite: isSectorFavorite
//                     });
//                 }
//             });

//         return Array.from(sectorsMap.values());
//     };

//     // Get grades for a product and sector
//     const getGradesForSector = (productName, sectorName) => {
//         return allGrades.filter(
//             grade => grade.product === productName && grade.subCategory === sectorName
//         );
//     };

//     // Toggle favorite for a grade
//     const toggleGradeFavorite = async (gradeId, isCurrentlyFavorite) => {
//         try {
//             const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;
//             const currentVendorId = vendorId ? parseInt(vendorId) : null;

//             if (!currentVendorId) {
//                 console.error('Vendor ID not found in props');
//                 return;
//             }

//             const payload = {
//                 traderId: currentVendorId, // Use vendorId from props
//                 gradeId: parseInt(gradeId),
//                 addingToFavourite: !isCurrentlyFavorite
//             };

//             console.log('Toggle Grade Favorite Payload:', payload);

//             const response = await axios.put(`${baseURL}grades/add-favorite`, payload, {
//                 headers: {
//                     'Authorization': `Bearer ${auth?.data?.token}`,
//                     'Content-Type': 'application/json'
//                 }
//             });

//             if (response.status === 200) {
//                 // Update local state to reflect the change
//                 setAllGrades(prevGrades =>
//                     prevGrades.map(grade =>
//                         grade.id === gradeId
//                             ? { ...grade, isFavorite: !isCurrentlyFavorite }
//                             : grade
//                     )
//                 );
//             }
//         } catch (error) {
//             console.error('Error toggling grade favorite:', error);
//         }
//     };

//     // Toggle favorite for a sector
//     const toggleSectorFavorite = async (sectorId, isCurrentlyFavorite) => {
//         try {
//             const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;
//             const currentVendorId = vendorId ? parseInt(vendorId) : null;

//             if (!currentVendorId) {
//                 console.error('Vendor ID not found in props');
//                 return;
//             }

//             const payload = {
//                 traderId: currentVendorId, // Use vendorId from props
//                 subCategoryId: parseInt(sectorId),
//                 addingToFavourite: !isCurrentlyFavorite
//             };

//             console.log('Toggle Sector Favorite Payload:', payload);

//             const response = await axios.put(`${baseURL}grades/add-favorite-sub-category`, payload, {
//                 headers: {
//                     'Authorization': `Bearer ${auth?.data?.token}`,
//                     'Content-Type': 'application/json'
//                 }
//             });

//             if (response.status === 200) {
//                 // Refresh the grades data to update sector favorite status
//                 const sectorsForProduct = getSectorsForProduct(selectedProduct);

//                 // Update allGrades to reflect sector favorite change
//                 setAllGrades(prevGrades =>
//                     prevGrades.map(grade => {
//                         if (grade.subCategoryId === sectorId) {
//                             return { ...grade, isFavorite: !isCurrentlyFavorite };
//                         }
//                         return grade;
//                     })
//                 );

//                 console.log('Sector favorite status updated successfully');
//             }
//         } catch (error) {
//             console.error('Error toggling sector favorite:', error);
//         }
//     };

//     const sectors = getSectorsForProduct(selectedProduct);
//     const grades = selectedSector ? getGradesForSector(selectedProduct, selectedSector) : [];

//     const handleProductClick = (productName) => {
//         setSelectedProduct(productName);
//         const sectorsForProduct = getSectorsForProduct(productName);
//         if (sectorsForProduct.length > 0) {
//             setSelectedSector(sectorsForProduct[0].name);
//         } else {
//             setSelectedSector(null);
//         }
//     };

//     const handleSectorClick = (sectorName) => {
//         setSelectedSector(sectorName);
//     };

//     // Sort grades to show favorites first
//     const sortedGrades = [...grades].sort((a, b) => {
//         if (a.isFavorite && !b.isFavorite) return -1;
//         if (!a.isFavorite && b.isFavorite) return 1;
//         return 0;
//     });

//     if (loading) {
//         return (
//             <div className="min-h-screen bg-gray-50 p-6">
//                 <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
//                     <h5 className="text-blue-600 font-semibold text-lg bold" style={{ fontSize: "18px", fontWeight: "bold" }}>Favorite Grade</h5>
//                 </div>
//                 <div className="bg-white rounded-lg shadow-sm p-10 text-center text-gray-500">
//                     Loading data...
//                 </div>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="min-h-screen bg-gray-50 p-6">
//                 <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
//                     <h5 className="text-blue-600 font-semibold text-lg bold" style={{ fontSize: "18px", fontWeight: "bold" }}>Favorite Grade</h5>
//                 </div>
//                 <div className="bg-white rounded-lg shadow-sm p-10 text-center text-red-500">
//                     {error}
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="min-h-screen bg-gray-50 p-6">
//             {/* Header */}
//             <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
//                 <h5 className="text-blue-600 font-semibold text-lg bold" style={{ fontSize: "18px", fontWeight: "bold" }}>Favorite Grade</h5>
//             </div>

//             {/* Main Content - Side by Side Columns */}
//             <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//                 <div className="flex border-b bg-gray-50" style={{ display: "flex", gap: "269px", fontSize: "16px" }}>
//                     <div className="w-1/4 p-3 border-r font-semibold text-gray-700">
//                         Products
//                     </div>
//                     <div className="w-1/4 p-3 border-r font-semibold text-gray-700" style={{ marginLeft: "35px" }}>
//                         Sector
//                     </div>
//                     <div className="flex-1 p-3 font-semibold text-gray-700">
//                         Grades
//                     </div>
//                 </div>

//                 {/* Content Row */}
//                 <div className="flex" style={{ display: "flex", gap: "203px" }}>
//                     {/* Products Column - Dynamic */}
//                     <div className="w-1/4 border-r" style={{ maxHeight: '500px', overflowY: 'auto' }}>
//                         {products.map((product) => (
//                             <div
//                                 key={product.id}
//                                 onClick={() => handleProductClick(product.name)}
//                                 className="flex items-center justify-between px-4 py-3 cursor-pointer text-sm transition-colors border-b"
//                                 style={{
//                                     backgroundColor: selectedProduct === product.name ? '#212529' : '#ffffff',
//                                     color: selectedProduct === product.name ? '#ffffff' : '#374151',
//                                     fontWeight: selectedProduct === product.name ? '600' : '400'
//                                 }}
//                             >
//                                 <span>{product.name}</span>
//                                 <ChevronRight
//                                     className="w-4 h-4"
//                                     style={{ color: selectedProduct === product.name ? '#ffffff' : '#9ca3af' }}
//                                 />
//                             </div>
//                         ))}
//                     </div>

//                  {/* Sector Column - Dynamic */}
//                     <div className="w-1/4 border-r" style={{ maxHeight: '500px', overflowY: 'auto' }}>
//                         {sectors.length > 0 ? (
//                             sectors.map((sector) => (
//                                 <div
//                                     key={sector.id}
//                                     onClick={() => handleSectorClick(sector.name)}
//                                     className="flex items-center justify-between px-4 py-3 cursor-pointer text-sm transition-colors"
//                                     style={{
//                                         borderBottom: selectedSector === sector.name ? '2px solid #212529' : '1px solid #e5e7eb',
//                                         color: '#374151',
//                                         fontWeight: selectedSector === sector.name ? '600' : '400',
//                                         backgroundColor: '#ffffff'
//                                     }}
//                                 >
//                                     <div className="flex items-center gap-2">
//                                         <Star
//                                             className="w-4 h-4 cursor-pointer"
//                                             style={{
//                                                 color: sector.isFavorite ? '#FFD700' : '#9ca3af',
//                                                 fill: sector.isFavorite ? '#FFD700' : 'none'
//                                             }}
//                                             onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 toggleSectorFavorite(sector.id, sector.isFavorite);
//                                             }}
//                                         />
//                                         <span>{sector.name}</span>
//                                     </div>
//                                     <ChevronRight
//                                         className="w-4 h-4"
//                                         style={{ color: '#9ca3af' }}
//                                     />
//                                 </div>
//                             ))
//                         ) : (
//                             <div className="text-center text-gray-500 py-10">No sectors available</div>
//                         )}
//                     </div>

//                     {/* Grades Column - Dynamic */}
//                     <div className="flex-1 p-5" style={{ marginLeft: "-46px", marginTop: "-26px" }}>
//                         {sortedGrades.length > 0 ? (
//                             <div className="grid grid-cols-2 gap-4">
//                                 {sortedGrades.map((grade) => (
//                                     <div
//                                         key={grade.id}
//                                         className="flex items-center gap-2 border border-gray-200 rounded-md p-3 hover:bg-gray-50 cursor-pointer"
//                                     >
//                                         <Star
//                                             className="w-4 h-4 cursor-pointer"
//                                             style={{
//                                                 color: grade.isFavorite ? '#FFD700' : '#9ca3af',
//                                                 fill: grade.isFavorite ? '#FFD700' : 'none'
//                                             }}
//                                             onClick={() => toggleGradeFavorite(grade.id, grade.isFavorite)}
//                                         />
//                                         <span className="text-sm text-gray-700">{grade.name}</span>
//                                     </div>
//                                 ))}
//                             </div>
//                         ) : (
//                             <div className="text-center text-gray-500 py-10">
//                                 No grades available for this sector
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default FavoriteGrade;

// with the help of this code sector and grade mark favrate but if one sector mark favrate then all grades are not set favrate ------------------------------

// import React, { useState, useEffect, useContext } from "react";
// import { Star, ChevronRight } from "lucide-react";
// import axios from "axios";
// import { authContext } from "contexts/AuthContext";

// const FavoriteGrade = ({ vendorId }) => {
//   const [products, setProducts] = useState([]);
//   const [allGrades, setAllGrades] = useState([]);
//   const [allSubCategories, setAllSubCategories] = useState([]);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [selectedSector, setSelectedSector] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const { auth } = useContext(authContext);

//   // Get unique sectors for a product with their IDs and favorite status
//   // Use a function declaration (hoisted) so it's safe to use before definition.
//   function getSectorsForProduct(productName, gradesData = allGrades, subCategoriesData = allSubCategories) {
//     if (!productName) return [];

//     const sectorsMap = new Map();

//     gradesData
//       .filter((grade) => grade.product === productName && grade.subCategory && grade.subCategoryId != null)
//       .forEach((grade) => {
//         if (!sectorsMap.has(grade.subCategoryId)) {
//           // Find the sector's favorite status from sub-categories API
//           const subCategoryData = subCategoriesData.find((sc) => sc.id === grade.subCategoryId);
//           const isFavorite = subCategoryData ? subCategoryData.isFavorite : false;

//           // use property shorthand
//           sectorsMap.set(grade.subCategoryId, {
//             name: grade.subCategory,
//             id: grade.subCategoryId,
//             isFavorite
//           });
//         }
//       });

//     const sectors = Array.from(sectorsMap.values());
//     // optional: remove duplicates by id already ensured by Map
//     return sectors;
//   }

//   // Fetch products and grades
//   useEffect(() => {
//     const fetchData = async () => {
//       if (!vendorId) {
//         setError("Vendor ID is required");
//         setLoading(false);
//         return;
//       }

//       try {
//         setLoading(true);
//         const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;

//         // Fetch all four APIs in parallel
//         const [
//           productsResponse,
//           gradesResponse,
//           traderGradesResponse,
//           subCategoriesResponse
//         ] = await Promise.all([
//           axios.get(`${baseURL}grades/products`),
//           axios.get(`${baseURL}grades/getall`),
//           axios.get(`${baseURL}grades/trader-grades?traderId=${vendorId}&subCategoryId=&searchTerm=&offset=0&limit=1000`),
//           axios.get(`${baseURL}grades/sub-categories?productId=&traderId=${vendorId}`)
//         ]);

//         setProducts(productsResponse.data || []);

//         // Store sub-categories data with favorite status
//         const subCategoriesData = subCategoriesResponse.data || [];
//         setAllSubCategories(subCategoriesData);

//         // Get favorite grade IDs from trader-grades API
//         const traderGrades = (traderGradesResponse.data && traderGradesResponse.data.data) || [];
//         const favoriteGradeIds = new Set(
//           traderGrades.filter((grade) => grade.isFavorite === true).map((grade) => grade.id)
//         );

//         // Map grades data with isFavorite based on trader-grades API
//         const gradesData = (gradesResponse.data && gradesResponse.data.data) || [];
//         const gradesWithFavorites = gradesData.map((grade) => {
//           const isFavorite = favoriteGradeIds.has(grade.id);
//           return {
//             ...grade,
//             isFavorite
//           };
//         });

//         setAllGrades(gradesWithFavorites);

//         // Set first product as selected by default
//         if (Array.isArray(productsResponse.data) && productsResponse.data.length > 0) {
//           const firstProduct = productsResponse.data[0].name;
//           setSelectedProduct(firstProduct);

//           // Get sectors for first product
//           const sectorsForProduct = getSectorsForProduct(firstProduct, gradesWithFavorites, subCategoriesData);
//           if (sectorsForProduct.length > 0) {
//             setSelectedSector(sectorsForProduct[0].name);
//           }
//         }

//         setError(null);
//       } catch (err) {
//         console.error("Error fetching data:", err);
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//     // vendorId intentionally in deps
//   }, [vendorId]);

//   // Recalculate sectors when sub-categories or selectedProduct change
//   useEffect(() => {
//     if (selectedProduct && allSubCategories.length > 0) {
//       const sectorsForProduct = getSectorsForProduct(selectedProduct);
//       // Only update selected sector if it's not already set
//       if (sectorsForProduct.length > 0 && !selectedSector) {
//         setSelectedSector(sectorsForProduct[0].name);
//       }
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [allSubCategories, selectedProduct]);

//   // Get grades for a product and sector
//   const getGradesForSector = (productName, sectorName) => {
//     if (!productName || !sectorName) return [];
//     return allGrades.filter((grade) => grade.product === productName && grade.subCategory === sectorName);
//   };

//   // Toggle favorite for a grade
//   const toggleGradeFavorite = async (gradeId, isCurrentlyFavorite) => {
//     try {
//       const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;
//       const currentVendorId = vendorId ? parseInt(vendorId, 10) : null;

//       if (!currentVendorId) {
//         console.error("Vendor ID not found in props");
//         return;
//       }

//       const payload = {
//         traderId: currentVendorId,
//         gradeId: parseInt(gradeId, 10),
//         addingToFavourite: !isCurrentlyFavorite
//       };

//       const response = await axios.put(`${baseURL}grades/add-favorite`, payload, {
//         headers: {
//           Authorization: `Bearer ${auth?.data?.token}`,
//           "Content-Type": "application/json"
//         }
//       });

//       if (response.status === 200) {
//         // Update local state to reflect the change
//         setAllGrades((prevGrades) =>
//           prevGrades.map((grade) => (grade.id === gradeId ? { ...grade, isFavorite: !isCurrentlyFavorite } : grade))
//         );
//       }
//     } catch (err) {
//       console.error("Error toggling grade favorite:", err);
//     }
//   };

//   // Toggle favorite for a sector
//   const toggleSectorFavorite = async (sectorId, isCurrentlyFavorite) => {
//     try {
//       const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;
//       const currentVendorId = vendorId ? parseInt(vendorId, 10) : null;

//       if (!currentVendorId) {
//         console.error("Vendor ID not found in props");
//         return;
//       }

//       const payload = {
//         traderId: currentVendorId,
//         subCategoryId: parseInt(sectorId, 10),
//         addingToFavourite: !isCurrentlyFavorite
//       };

//       const response = await axios.put(`${baseURL}grades/add-favorite-sub-category`, payload, {
//         headers: {
//           Authorization: `Bearer ${auth?.data?.token}`,
//           "Content-Type": "application/json"
//         }
//       });

//       if (response.status === 200) {
//         // Update the sub-categories state with new favorite status
//         setAllSubCategories((prevSubCategories) =>
//           prevSubCategories.map((sc) => (sc.id === sectorId ? { ...sc, isFavorite: !isCurrentlyFavorite } : sc))
//         );
//       }
//     } catch (err) {
//       console.error("Error toggling sector favorite:", err);
//     }
//   };

//   const sectors = getSectorsForProduct(selectedProduct);
//   const grades = selectedSector ? getGradesForSector(selectedProduct, selectedSector) : [];

//   const handleProductClick = (productName) => {
//     setSelectedProduct(productName);
//     const sectorsForProduct = getSectorsForProduct(productName);
//     if (sectorsForProduct.length > 0) {
//       setSelectedSector(sectorsForProduct[0].name);
//     } else {
//       setSelectedSector(null);
//     }
//   };

//   const handleSectorClick = (sectorName) => {
//     setSelectedSector(sectorName);
//   };

//   // Sort sectors to show favorites first
//   const sortedSectors = [...sectors].sort((a, b) => {
//     if (a.isFavorite && !b.isFavorite) return -1;
//     if (!a.isFavorite && b.isFavorite) return 1;
//     return 0;
//   });

//   // Sort grades to show favorites first
//   const sortedGrades = [...grades].sort((a, b) => {
//     if (a.isFavorite && !b.isFavorite) return -1;
//     if (!a.isFavorite && b.isFavorite) return 1;
//     return 0;
//   });

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 p-6">
//         <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
//           <h5 className="text-blue-600 font-semibold text-lg bold" style={{ fontSize: "18px", fontWeight: "bold" }}>
//             Favorite Grade
//           </h5>
//         </div>
//         <div className="bg-white rounded-lg shadow-sm p-10 text-center text-gray-500">Loading data...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen bg-gray-50 p-6">
//         <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
//           <h5 className="text-blue-600 font-semibold text-lg bold" style={{ fontSize: "18px", fontWeight: "bold" }}>
//             Favorite Grade
//           </h5>
//         </div>
//         <div className="bg-white rounded-lg shadow-sm p-10 text-center text-red-500">{error}</div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50 p-6">
//       {/* Header */}
//       <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
//         <h5 className="text-blue-600 font-semibold text-lg bold" style={{ fontSize: "18px", fontWeight: "bold" }}>
//           Favorite Grade
//         </h5>
//       </div>

//       {/* Main Content - Side by Side Columns */}
//       <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//         <div className="flex border-b bg-gray-50" style={{ display: "flex", gap: "132px", fontSize: "16px" }}>
//           <div className="w-1/4 p-3 border-r font-semibold text-gray-700">Products</div>
//           <div className="w-1/4 p-3 border-r font-semibold text-gray-700" style={{ marginLeft: "35px" }}>
//             Sector
//           </div>
//           <div className="flex-1 p-3 font-semibold text-gray-700">Grades</div>
//         </div>

//         {/* Content Row */}
//         <div className="flex" style={{ display: "flex", gap: "52px" }}>
//           {/* Products Column - Dynamic */}
//           <div className="w-1/4 border-r" style={{ maxHeight: "500px", overflowY: "auto" }}>
//             {products.map((product) => (
//               <div
//                 key={product.id}
//                 onClick={() => handleProductClick(product.name)}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") handleProductClick(product.name);
//                 }}
//                 role="button"
//                 tabIndex={0}
//                 className="flex items-center justify-between px-4 py-3 cursor-pointer text-sm transition-colors border-b"
//                 style={{
//                   backgroundColor: selectedProduct === product.name ? "#212529" : "#ffffff",
//                   color: selectedProduct === product.name ? "#ffffff" : "#374151",
//                   fontWeight: selectedProduct === product.name ? "600" : "400"
//                 }}
//               >
//                 <span>{product.name}</span>
//                 <ChevronRight
//                   className="w-4 h-4"
//                   style={{ color: selectedProduct === product.name ? "#ffffff" : "#9ca3af" }}
//                 />
//               </div>
//             ))}
//           </div>

//           {/* Sector Column - Dynamic with sorted sectors */}
//           <div className="w-1/4 border-r" style={{ maxHeight: "500px", overflowY: "auto" }}>
//             {sortedSectors.length > 0 ? (
//               sortedSectors.map((sector) => (
//                 <div
//                   key={sector.id}
//                   onClick={() => handleSectorClick(sector.name)}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") handleSectorClick(sector.name);
//                   }}
//                   role="button"
//                   tabIndex={0}
//                   className="flex items-center justify-between px-4 py-3 cursor-pointer text-sm transition-colors"
//                   style={{
//                     borderBottom: selectedSector === sector.name ? "2px solid #212529" : "1px solid #e5e7eb",
//                     color: "#374151",
//                     fontWeight: selectedSector === sector.name ? "600" : "400",
//                     backgroundColor: "#ffffff"
//                   }}
//                 >
//                   <div className="flex items-center gap-2">
//                     <Star
//                       className="w-4 h-4 cursor-pointer"
//                       style={{
//                         color: sector.isFavorite ? "#FFD700" : "#9ca3af",
//                         fill: sector.isFavorite ? "#FFD700" : "none"
//                       }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         toggleSectorFavorite(sector.id, sector.isFavorite);
//                       }}
//                     />
//                     <span>{sector.name}</span>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="text-center text-gray-500 py-10">No sectors available</div>
//             )}
//           </div>

//           {/* Grades Column - Dynamic */}
//           <div className="flex-1 p-5" style={{ marginLeft: "-46px", marginTop: "-26px" }}>
//             {sortedGrades.length > 0 ? (
//               <div className="grid grid-cols-2 gap-4">
//                 {sortedGrades.map((grade) => (
//                   <div
//                     key={grade.id}
//                     className="flex items-center gap-2 border border-gray-200 rounded-md p-3 hover:bg-gray-50 cursor-pointer"
//                   >
//                     <Star
//                       className="w-4 h-4 cursor-pointer"
//                       style={{
//                         color: grade.isFavorite ? "#FFD700" : "#9ca3af",
//                         fill: grade.isFavorite ? "#FFD700" : "none"
//                       }}
//                       onClick={() => toggleGradeFavorite(grade.id, grade.isFavorite)}
//                     />
//                     <span className="text-sm text-gray-700">{grade.name}</span>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <div className="text-center text-gray-500 py-10">No grades available for this sector</div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default FavoriteGrade;

// With the help of this code if sector mark favrate then all grade mark favrate ----------------------------------------

import React, { useState, useEffect, useContext } from 'react';
import { Star, ChevronRight } from 'lucide-react';
import axios from 'axios';
import { authContext } from 'contexts/AuthContext';

const FavoriteGrade = ({ vendorId, embedded = false, onTimelineRefresh }) => {
  const [products, setProducts] = useState([]);
  const [allGrades, setAllGrades] = useState([]);
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSector, setSelectedSector] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { auth } = useContext(authContext);

  // Get unique sectors for a product with their IDs and favorite status
  function getSectorsForProduct(
    productName,
    gradesData = allGrades,
    subCategoriesData = allSubCategories,
  ) {
    if (!productName) return [];

    const sectorsMap = new Map();

    gradesData
      .filter(
        (grade) =>
          grade.product === productName &&
          grade.subCategory &&
          grade.subCategoryId != null,
      )
      .forEach((grade) => {
        if (!sectorsMap.has(grade.subCategoryId)) {
          const subCategoryData = subCategoriesData.find(
            (sc) => sc.id === grade.subCategoryId,
          );
          const isFavorite = subCategoryData
            ? subCategoryData.isFavorite
            : false;

          sectorsMap.set(grade.subCategoryId, {
            name: grade.subCategory,
            id: grade.subCategoryId,
            isFavorite,
          });
        }
      });

    const sectors = Array.from(sectorsMap.values());
    return sectors;
  }

  // Fetch products and grades
  useEffect(() => {
    const fetchData = async () => {
      if (!vendorId) {
        setError('Vendor ID is required');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;

        const [
          productsResponse,
          gradesResponse,
          traderGradesResponse,
          subCategoriesResponse,
        ] = await Promise.all([
          axios.get(`${baseURL}grades/products`),
          axios.get(`${baseURL}grades/getall`),
          axios.get(
            `${baseURL}grades/trader-grades?traderId=${vendorId}&subCategoryId=&searchTerm=&offset=0&limit=1000`,
          ),
          axios.get(
            `${baseURL}grades/sub-categories?productId=&traderId=${vendorId}`,
          ),
        ]);

        setProducts(productsResponse.data || []);

        const subCategoriesData = subCategoriesResponse.data || [];
        setAllSubCategories(subCategoriesData);

        const traderGrades =
          (traderGradesResponse.data && traderGradesResponse.data.data) || [];
        const favoriteGradeIds = new Set(
          traderGrades
            .filter((grade) => grade.isFavorite === true)
            .map((grade) => grade.id),
        );

        const gradesData =
          (gradesResponse.data && gradesResponse.data.data) || [];
        const gradesWithFavorites = gradesData.map((grade) => {
          const isFavorite = favoriteGradeIds.has(grade.id);
          return {
            ...grade,
            isFavorite,
          };
        });

        setAllGrades(gradesWithFavorites);

        if (
          Array.isArray(productsResponse.data) &&
          productsResponse.data.length > 0
        ) {
          const firstProduct = productsResponse.data[0].name;
          setSelectedProduct(firstProduct);

          const sectorsForProduct = getSectorsForProduct(
            firstProduct,
            gradesWithFavorites,
            subCategoriesData,
          );
          if (sectorsForProduct.length > 0) {
            setSelectedSector(sectorsForProduct[0].name);
          }
        }

        setError(null);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load data');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [vendorId]);

  useEffect(() => {
    if (selectedProduct && allSubCategories.length > 0) {
      const sectorsForProduct = getSectorsForProduct(selectedProduct);
      if (sectorsForProduct.length > 0 && !selectedSector) {
        setSelectedSector(sectorsForProduct[0].name);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSubCategories, selectedProduct]);

  // Get grades for a product and sector
  const getGradesForSector = (productName, sectorName) => {
    if (!productName || !sectorName) return [];
    return allGrades.filter(
      (grade) =>
        grade.product === productName && grade.subCategory === sectorName,
    );
  };

  // Toggle favorite for a grade
  const toggleGradeFavorite = async (gradeId, isCurrentlyFavorite) => {
    try {
      const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;
      const currentVendorId = vendorId ? parseInt(vendorId, 10) : null;

      if (!currentVendorId) {
        console.error('Vendor ID not found in props');
        return;
      }

      const payload = {
        traderId: currentVendorId,
        gradeId: parseInt(gradeId, 10),
        addingToFavourite: !isCurrentlyFavorite,
      };

      const response = await axios.put(
        `${baseURL}grades/add-favorite`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${auth?.data?.token}`,
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.status === 200) {
        setAllGrades((prevGrades) =>
          prevGrades.map((grade) =>
            grade.id === gradeId
              ? { ...grade, isFavorite: !isCurrentlyFavorite }
              : grade,
          ),
        );
        onTimelineRefresh?.();
      }
    } catch (err) {
      console.error('Error toggling grade favorite:', err);
    }
  };

  // Toggle favorite for a sector - NOW ALSO FAVORITES ALL GRADES IN THAT SECTOR
  const toggleSectorFavorite = async (
    sectorId,
    isCurrentlyFavorite,
    sectorName,
  ) => {
    try {
      const baseURL = process.env.REACT_APP_REST_API_ENDPOINT;
      const currentVendorId = vendorId ? parseInt(vendorId, 10) : null;

      if (!currentVendorId) {
        console.error('Vendor ID not found in props');
        return;
      }

      // First, toggle the sector favorite status
      const sectorPayload = {
        traderId: currentVendorId,
        subCategoryId: parseInt(sectorId, 10),
        addingToFavourite: !isCurrentlyFavorite,
      };

      const sectorResponse = await axios.put(
        `${baseURL}grades/add-favorite-sub-category`,
        sectorPayload,
        {
          headers: {
            Authorization: `Bearer ${auth?.data?.token}`,
            'Content-Type': 'application/json',
          },
        },
      );

      if (sectorResponse.status === 200) {
        // Update the sub-categories state with new favorite status
        setAllSubCategories((prevSubCategories) =>
          prevSubCategories.map((sc) =>
            sc.id === sectorId
              ? { ...sc, isFavorite: !isCurrentlyFavorite }
              : sc,
          ),
        );

        // Get all grades for this sector
        const gradesInSector = allGrades.filter(
          (grade) =>
            grade.subCategoryId === sectorId &&
            grade.subCategory === sectorName,
        );

        // If marking sector as favorite, mark all grades as favorite too in UI
        if (!isCurrentlyFavorite) {
          // Update local state for all grades in this sector
          setAllGrades((prevGrades) =>
            prevGrades.map((grade) =>
              grade.subCategoryId === sectorId &&
              grade.subCategory === sectorName
                ? { ...grade, isFavorite: true }
                : grade,
            ),
          );
          onTimelineRefresh?.();
        } else {
          // Unfavoriting sector - unfavorite all grades in UI
          // Update local state for all grades in this sector
          setAllGrades((prevGrades) =>
            prevGrades.map((grade) =>
              grade.subCategoryId === sectorId &&
              grade.subCategory === sectorName
                ? { ...grade, isFavorite: false }
                : grade,
            ),
          );
          onTimelineRefresh?.();
        }
      }
    } catch (err) {
      console.error('Error toggling sector favorite:', err);
    }
  };

  const sectors = getSectorsForProduct(selectedProduct);
  const grades = selectedSector
    ? getGradesForSector(selectedProduct, selectedSector)
    : [];

  const handleProductClick = (productName) => {
    setSelectedProduct(productName);
    const sectorsForProduct = getSectorsForProduct(productName);
    if (sectorsForProduct.length > 0) {
      setSelectedSector(sectorsForProduct[0].name);
    } else {
      setSelectedSector(null);
    }
  };

  const handleSectorClick = (sectorName) => {
    setSelectedSector(sectorName);
  };

  // Sort sectors to show favorites first
  const sortedSectors = [...sectors].sort((a, b) => {
    if (a.isFavorite && !b.isFavorite) return -1;
    if (!a.isFavorite && b.isFavorite) return 1;
    return 0;
  });

  // Sort grades to show favorites first
  const sortedGrades = [...grades].sort((a, b) => {
    if (a.isFavorite && !b.isFavorite) return -1;
    if (!a.isFavorite && b.isFavorite) return 1;
    return 0;
  });

  if (loading) {
    return (
      <div
        className={!embedded ? 'min-h-screen bg-gray-50 p-6' : ''}
        style={
          embedded
            ? { minHeight: 'auto', background: 'transparent', padding: 0 }
            : {}
        }
      >
        {!embedded && (
          <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
            <h5
              className="text-blue-600 font-semibold text-lg bold"
              style={{ fontSize: '18px', fontWeight: 'bold' }}
            >
              Favourite Grade
            </h5>
          </div>
        )}
        <div className="bg-white rounded-lg shadow-sm p-10 text-center text-gray-500">
          Loading data...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={!embedded ? 'min-h-screen bg-gray-50 p-6' : ''}
        style={
          embedded
            ? { minHeight: 'auto', background: 'transparent', padding: 0 }
            : {}
        }
      >
        {!embedded && (
          <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
            <h5
              className="text-blue-600 font-semibold text-lg bold"
              style={{ fontSize: '18px', fontWeight: 'bold' }}
            >
              Favourite Grade
            </h5>
          </div>
        )}
        <div className="bg-white rounded-lg shadow-sm p-10 text-center text-red-500">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div
      className={!embedded ? 'min-h-screen bg-gray-50 p-6' : ''}
      style={
        embedded
          ? { minHeight: 'auto', background: 'transparent', padding: 0 }
          : {}
      }
    >
      {/* Header */}
      {!embedded && (
        <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
          <h5
            className="text-blue-600 font-semibold text-lg bold"
            style={{ fontSize: '18px', fontWeight: 'bold' }}
          >
            Favourite Grade
          </h5>
        </div>
      )}

      {/* Main Content - Side by Side Columns */}
      <div className="bg-white rounded-lg shadow-sm overflow-hidden">
        <div
          className="flex border-b bg-gray-50"
          style={{ display: 'flex', gap: '132px', fontSize: '16px' }}
        >
          <div className="w-1/4 p-3 border-r font-semibold text-gray-700">
            Products
          </div>
          <div
            className="w-1/4 p-3 border-r font-semibold text-gray-700"
            style={{ marginLeft: '35px' }}
          >
            Sector
          </div>
          <div className="flex-1 p-3 font-semibold text-gray-700">Grades</div>
        </div>

        {/* Content Row */}
        <div className="flex" style={{ display: 'flex', gap: '52px' }}>
          {/* Products Column - Dynamic */}
          <div
            className="w-1/4 border-r"
            style={{ height: '500px', overflowY: 'auto' }}
          >
            {products.map((product) => (
              <div
                key={product.id}
                onClick={() => handleProductClick(product.name)}
                onKeyDown={(e) => {
                  if (
                    e.key === 'Enter' ||
                    e.key === ' ' ||
                    e.key === 'Spacebar'
                  )
                    handleProductClick(product.name);
                }}
                role="button"
                tabIndex={0}
                className="flex items-center justify-between px-4 py-3 cursor-pointer text-sm transition-colors border-b"
                style={{
                  backgroundColor:
                    selectedProduct === product.name ? '#212529' : '#ffffff',
                  color:
                    selectedProduct === product.name ? '#ffffff' : '#374151',
                  fontWeight: selectedProduct === product.name ? '600' : '400',
                }}
              >
                <span>{product.name}</span>
                <ChevronRight
                  className="w-4 h-4"
                  style={{
                    color:
                      selectedProduct === product.name ? '#ffffff' : '#9ca3af',
                  }}
                />
              </div>
            ))}
          </div>

          {/* Sector Column - Dynamic with sorted sectors */}
          <div
            className="w-1/4 border-r"
            style={{ maxHeight: '500px', overflowY: 'auto' }}
          >
            {sortedSectors.length > 0 ? (
              sortedSectors.map((sector) => (
                <div
                  key={sector.id}
                  onClick={() => handleSectorClick(sector.name)}
                  onKeyDown={(e) => {
                    if (
                      e.key === 'Enter' ||
                      e.key === ' ' ||
                      e.key === 'Spacebar'
                    )
                      handleSectorClick(sector.name);
                  }}
                  role="button"
                  tabIndex={0}
                  className="flex items-center justify-between px-4 py-3 cursor-pointer text-sm transition-colors"
                  style={{
                    borderBottom:
                      selectedSector === sector.name
                        ? '2px solid #212529'
                        : '1px solid #e5e7eb',
                    color: '#374151',
                    fontWeight: selectedSector === sector.name ? '600' : '400',
                    backgroundColor: '#ffffff',
                  }}
                >
                  <div className="flex items-center gap-2">
                    <Star
                      className="w-4 h-4 cursor-pointer"
                      style={{
                        color: sector.isFavorite ? '#FFD700' : '#9ca3af',
                        fill: sector.isFavorite ? '#FFD700' : 'none',
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleSectorFavorite(
                          sector.id,
                          sector.isFavorite,
                          sector.name,
                        );
                      }}
                    />
                    <span>{sector.name}</span>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-gray-500 py-10">
                No sectors available
              </div>
            )}
          </div>

          {/* Grades Column - Dynamic */}
          <div
            className="flex-1 p-5"
            style={{
              marginLeft: '-46px',
              marginTop: '-26px',
              height: '500px',
              overflowY: 'auto',
            }}
          >
            {sortedGrades.length > 0 ? (
              <div className="grid grid-cols-2 gap-4">
                {sortedGrades.map((grade) => (
                  <div
                    key={grade.id}
                    className="flex items-center gap-2 border border-gray-200 rounded-md p-3 hover:bg-gray-50 cursor-pointer"
                  >
                    <Star
                      className="w-4 h-4 cursor-pointer"
                      style={{
                        color: grade.isFavorite ? '#FFD700' : '#9ca3af',
                        fill: grade.isFavorite ? '#FFD700' : 'none',
                      }}
                      onClick={() =>
                        toggleGradeFavorite(grade.id, grade.isFavorite)
                      }
                    />
                    <span className="text-sm text-gray-700">{grade.name}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center text-gray-500 py-10">
                No grades available for this sector
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FavoriteGrade;
